<div class="grid-container">
  <app-migration-banner></app-migration-banner>
  <h4 class="title">{{ 'home.information.title' | translate }}</h4>
  <app-information></app-information>
  <app-usage></app-usage>
</div>
